import { RLBaseService } from "./rl-base-service";
import { LocalCacheService } from "./local-cache-service";
import { PromiseCache } from "./promise-cache";
import * as moment from "moment";
import * as Models from "../ts/rlAdmin.models";

export class CurrencyConversionService extends RLBaseService {
    static $inject = ["$resource", "$q", "$log", "promiseCache", "localCacheService"];

    constructor(private $resource: ng.resource.IResourceService, private $q: ng.IQService, private $log: ng.ILogService, private promiseCache: PromiseCache, private localCacheService: LocalCacheService) {
        super($resource);
    }

    getCompanyCurrency() {
        return this.toRLService<Models.IDataResponse<string>>("/api/currencyconversion/getcompanycurrency").get().$promise;
    } 

    getConvertableCurrencyListOfValues(charValueSourceID: string, charValueSetID: string = null): ng.IPromise<Models.IDataResponse<Array<Models.ICharacteristicMetaDataValue>>> {
        var data = {
            charValueSourceID: charValueSourceID,
            charValueSetID: charValueSetID
        };
        var key = charValueSourceID + charValueSetID;
        return this.localCacheService.getCachedOrDoCachePromise(key, () => this.promiseCache.get(key, () => this.toRLService<Models.IDataResponse<Array<Models.ICharacteristicMetaDataValue>>>("/api/currencyconversion/getconvertablecurrencylistofvalues").get(data).$promise), moment.duration(1, "minute"));
    } 

    convertToGlobalCurrency(localCurrencySymbol: string, localCurrencyAmount: number) {
        var data = {
            currencySymbol: localCurrencySymbol,
            currencyAmount: localCurrencyAmount
        };
        return this.toRLService<Models.ICurrencyConversionResult>("/api/currencyconversion/converttoglobalcurrency").get(data).$promise;
    }
}